import './component';
import './preview';

Shopware.Service('cmsService').registerCmsBlock({
    name: 'acris-blog-image',
    label: 'acris-blog.blocks.blogImage.label',
    category: 'acris-blog',
    component: 'sw-cms-block-acris-blog-image',
    previewComponent: 'sw-cms-preview-acris-blog-image',
    defaultConfig: {
        marginBottom: '20px',
        marginTop: '20px',
        marginLeft: null,
        marginRight: null,
        sizingMode: 'boxed'
    },
    slots: {
        column: {
            type: 'acris-blog-image'
        },
    }
});
